<script setup lang="ts">
import { ref } from 'vue';
import { DividerComponent, AccordionContent, OverlayView } from '@hfc/ui-core';

const overlayOpen = ref(false);

const faqData = [
  {
    question: 'Do CEOs/Owners/ Spouses of Owners count as employees?',
    answer: 'Yes absolutely! However, they don’t count as employees towards the 1 employee minimum requirement for most small group plans. If you’re in this situation we recommend Individual and Family plans which are often the same price, and you could be eligible for a subsidy!'
  },
  {
    question: 'Do I select one plan for my whole team?',
    answer: 'In a small business quote, you’re not selecting one plan for your whole team, instead you’re choosing a basis for your contribution called a Reference Plan. Every employee will get to choose their own plan that best suits their needs. These prices just help you budget your contribution to their selected plan’s premiums.'
  },
  {
    question: 'What is a Reference Plan?',
    answer: 'A Reference Plan is the basis for calculating your contribution to your employees’ premiums. Your contribution to each employee must be 50% (or more) of their premium for your selected Reference Plan. If an employee selected a plan with a higher premium, your contribution would remain the same. If an employee selected a plan with a lower premium, so that your contribution exceeded the total cost of that plan, you may allow them to apply the difference to their dependents. <br /><br /> For example: The employer’s reference plan costs their employee $800 in monthly premiums and they are contributing 50% of that premium. The employer contribution to their premium would be $400 to that employee. <br /><br /> If that employee chooses a plan with a higher premium of $950 in monthly premiums. Their contribution would max out at $400 and the rest of the premium ($550) would be deducted from their paychecks. <br /><br /> If that employee selected a plan with a lower premium, of $500 the employer contribution would remain $400 and the rest of the premium ($100) would be deducted from their paychecks. <br /><br /> If that employee selected a plan with a much lower premium, of $300 the employer has the option of allowing all employees to use the excess contribution ($100) towards the cost of their dependents or not.'
  },
  {
    question: 'Who pays the bill?',
    answer: 'Insurance plans are a contract between the employer and the insurance company. This means the entire monthly premium for all your employees and their dependents is the responsibility of the employer. You or your payroll staff will then deduct employee premiums (minus your contribution) from their paychecks.'
  },
  {
    question: 'Are you Covered California?',
    answer: 'No, we are a licensed storefront for Covered California. Our services are at no extra cost to you and do not affect the price of your plans. You get the added benefit of our licensed agents guiding you through the process for the same price as if you did everything on your own.'
  },
  {
    question: 'What’s the minimum Contribution?',
    answer: 'For Medical insurance you need to offer a minimum of 50% or more of the cheapest plan towards the Employee’s premium. There is no requirement on your employee’s dependents or most Dental or Vision plans.'
  },
  {
    question: 'Do I have to offer health insurance to my company?',
    answer: 'Only businesses with 50 or more full-time equivalent (FTE) employees must offer health insurance to their employees.'
  },
  {
    question: 'Do I have to offer health insurance to everyone in my company?',
    answer: 'If you are offering health insurance benefits to one full-time employee (30+ hrs per week) you need to offer it to all full-time employees. You may optionally lower that threshold to part-time employees (as low as 20+ hrs per week).'
  },
  {
    question: 'Do I have to wait until Open Enrollment to offer my Employees health insurance benefits?',
    answer: 'Employers can sign a new small business health insurance contract at any time. After that changes to their plan must happen on renewal, on your plan’s anniversary. Employers may terminate coverage after an employee is terminated and must add full-time employees as they are hired.'
  },
  {
    question: 'When can Employees change their health insurance benefits?',
    answer: 'Employees can make changes to their plans annually on your renewal, similar to Covered California’s Open Enrollment but during your company’s renewal. And just like Covered California there are exceptions to this rule.'
  },
  {
    question: 'What is a waiting period?',
    answer: 'An employer must offer their health insurance benefits for all full-time employees. However, new employees may face a waiting period of up to 60 days, according to your benefits policies, provided all staff have the same requirement.'
  }
];

</script>
<template>
  <AccordionContent v-highlight="{ multipleCoincidences: true }" class="hidden xl:flex w-full" :title-full-width="false" :transparent="true" title-padding="p-0" closed-icon="chevron-down" closed-icon-color="text-blue-500" open-icon="chevron-up" open-icon-color="text-blue-500" content-class="p-0">
    <template #title>
      <span class="text-blue-500 text-lg font-semibold">FAQ’s</span>
    </template>
    <template #content>
      <template v-for="(item, index) in faqData" :key="index">
        <AccordionContent :transparent="true" closed-icon="chevron-down" closed-icon-color="text-blue-500" open-icon="chevron-up" open-icon-color="text-blue-500">
          <template #title>
            <span class="text-blue-600 text-normal font-medium">{{ item.question }}</span>
          </template>
          <template #content>
            <div v-html="item.answer" class="text-sm">
            </div>
          </template>
        </AccordionContent>
        <DividerComponent v-if="index < faqData.length - 1" extra-class="my-1" />
      </template>
    </template>
  </AccordionContent>
  <OverlayView class="flex xl:hidden" title="FAQ’s" v-model:is-open="overlayOpen" self-trigger scrollable @close="overlayOpen = false" :offset-top="170">
    <template #trigger>
      <hfc-icon icon="question" class="text-blue-500 text-xl" />
    </template>
    <div class="flex flex-col gap-4">
      <AccordionContent v-for="(item, index) in faqData" :key="index" class="w-full mb-2" closed-icon="chevron-down" closed-icon-color="text-blue-500" open-icon="chevron-up" open-icon-color="text-blue-500">
        <template #title>
          <span class="text-blue-600 text-normal font-medium">{{ item.question }}</span>
        </template>
        <template #content>
          <div v-html="item.answer" class="text-sm">
          </div>
        </template>
      </AccordionContent>
    </div>
  </OverlayView>
</template>
